import React, { useState } from 'react';

import { AppIcon, appStrings } from '@backrs_ui/common-ui';

import { IconButton, SxProps, Theme, Tooltip } from '@mui/material';

type GuideCopyActionProps = Readonly<{
  id: string;
  text: string;
}>;

const COPIED_TOOLTIP_MS = 2000;

/** Borderless copy icon that writes guide text to the clipboard and confirms with a tooltip. */
export const GuideCopyAction: React.FC<GuideCopyActionProps> = ({ id, text }) => {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error('Failed to copy guide text to clipboard:', error);

      return;
    }

    setCopied(true);
    setTimeout(() => setCopied(false), COPIED_TOOLTIP_MS);
  };

  return (
    <Tooltip
      title={copied ? appStrings.modules.actionTabs.copied : appStrings.modules.actionTabs.copy}
      placement="top"
      arrow
    >
      <IconButton
        id={id}
        aria-label={appStrings.modules.actionTabs.copy}
        onClick={handleClick}
        sx={buttonSx}
      >
        <AppIcon iconName="Copy01" diameter="20px" color="Colors/Foreground/fg-secondary" />
      </IconButton>
    </Tooltip>
  );
};

const buttonSx: SxProps<Theme> = ({ backrs }) => ({
  p: backrs.spacing['spacing-xs'],
  borderRadius: backrs.radius['radius-sm'],
});
